//** WhatsAppConfig Api
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import { setLoading } from '../../../../@core/components/skelton/store';
import showLoader from '@components/loader';

export const getWhatsAppConfig = createAsyncThunk('whatsAppSlice/get-whatsapp-configuration', async (_, { dispatch, rejectWithValue }) => {
    try {
        dispatch(setLoading(true));
        let whatsAppResponse = await axios.get('/get-whatsapp-configuration', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(whatsAppResponse?.data?.data);
    } catch (error) {
        dispatch(setLoading(false));
        console.log('err', error);
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(error);
    }
});

export const whatsAppConfig = createAsyncThunk('whatsAppSlice/whatsapp-configuration', async (data, { dispatch }) => {
    try {
        let whatsAppResponse = await axios.post('/whatsapp-configuration', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(whatsAppResponse?.data?.message || 'WhatsApp Added successfully.');
        dispatch(getWhatsAppConfig());
        return Promise.resolve(whatsAppResponse);
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        console.log('err', error);
        return Promise.reject(error);
    }
});

export const getWhatsAppAutomation = createAsyncThunk('whatsAppSlice/getWhatsAppAutomation', async (id, { dispatch }) => {
    showLoader(true);
    try {
        let whatsAppAutomationResponse = await axios.get('/whatsapp-configuration/automation/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(whatsAppAutomationResponse);
    } catch (error) {
        showLoader(false);
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        console.log('error during fetching whatsapp automation ', error?.response?.data);
        return Promise.reject(error?.response?.data);
    }
});

export const updateWhatsAppStatus = createAsyncThunk('whatsAppSlice/updateWhatsAppStatus', async (id, { dispatch }) => {
    try {
        let whatsAppResponse = await axios.put('/whatsapp-configuration/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(whatsAppResponse?.data?.message || 'WhatsApp Status Changed successfully.');
        await dispatch(getWhatsAppConfig());
        return Promise.resolve(whatsAppResponse);
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        console.log('err during update whatsapp status ', error?.response?.data);
        return Promise.reject(error?.response?.data);
    }
});

export const deleteWhatsAppConfig = createAsyncThunk('whatsAppSlice/deleteWhatsAppConfig', async (deleteId, { dispatch }) => {
    try {
        let whatsAppResponse = await axios.delete('/whatsapp-configuration/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(whatsAppResponse?.data?.message || 'WhatsApp deleted successfully.');
        await dispatch(getWhatsAppConfig());
        return Promise.resolve(whatsAppResponse);
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        console.log('err', error);
        return Promise.reject(error);
    }
});

export const getCustomWhatsappConfig = createAsyncThunk('whatsAppSlice/getCustomWhatsappConfig', async (_, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let customWhatsappResponse = await axios.get('/whatsapp-configuration/users', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
            dispatch(setLoading(false));
        return Promise.resolve(customWhatsappResponse);
    } catch (error) {
            dispatch(setLoading(false));
        console.log('err', error);
        return Promise.reject(error);
    }
});

export const updateCustomWhatsappConfig = createAsyncThunk('whatsAppSlice/updateCustomWhatsappConfig', async (data, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        const customWhatsappConfigResponse = await axios.post('/whatsapp-configuration/custom-config ', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        toast.success(customWhatsappConfigResponse?.data?.message || 'WhatsApp Configured successfully.');
        return Promise.resolve(customWhatsappConfigResponse);
    } catch (error) {
            dispatch(setLoading(false));
        console.log('err', error);
        return Promise.reject(error);
    }
});

export const whatsAppSlice = createSlice({
    name: 'whatsAppSlice',
    initialState: {
        whatsAppStatusData: [],
        whatsAppData: [],
        whatsAppStaus: [],
        customWhatsAppData: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getWhatsAppConfig.fulfilled, (state, action) => {
            state.whatsAppData = action.payload;
            return;
        }),
            builder.addCase(getWhatsAppAutomation.fulfilled, (state, action) => {
                state.whatsAppStaus = action?.payload?.data?.data;
                return;
            }),
            builder.addCase(getCustomWhatsappConfig.fulfilled, (state, action) => {
                state.customWhatsAppData = action?.payload?.data?.data;
                return;
            });
    }
});

export default whatsAppSlice.reducer;
